import { useParams } from 'react-router-dom';
import { FinancePage } from '../ProjectManagement/Finance/FinancePage';

/** Finance — MRR, customers and receivables, P&L and cash, tool costs. */
export function Finance() {
  const { tab } = useParams<{ tab?: string }>();
  return <FinancePage tab={tab} />;
}
